/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var CommodityEnum;

(function (CommodityEnum) {
  CommodityEnum["AIR_CONDITIONING"] = "airConditioning";
  CommodityEnum["AIR_FREIGHT"] = "airFreight";
  CommodityEnum["AIRCRAFT_ENGINES"] = "aircraftEngines";
  CommodityEnum["AIRCRAFT_PARTS"] = "aircraftParts";
  CommodityEnum["AMAZON"] = "amazon";
  CommodityEnum["APPLIANCES_MAJOR"] = "appliancesMajor";
  CommodityEnum["APPLIANCES_SMALL"] = "appliancesSmall";
  CommodityEnum["ASPHALT_LIQUID"] = "asphaltLiquid";
  CommodityEnum["AUTO_ACCESSORIES"] = "autoAccessories";
  CommodityEnum["AUTO_MOBILE_MAX_LIMIT"] = "autoMobileMaxLimit";
  CommodityEnum["AUTO_WRECK_SERVICE"] = "autoWreckService";
  CommodityEnum["BAKED_GOODS"] = "bakedGoods";
  CommodityEnum["BATTERIES"] = "batteries";
  CommodityEnum["BATTERIES_LITHIUM"] = "batteriesLithium";
  CommodityEnum["BEER"] = "beer";
  CommodityEnum["LIQUOR"] = "liquor";
  CommodityEnum["SOFT_DRINKS"] = "softDrinks";
  CommodityEnum["WINES"] = "wines";
  CommodityEnum["TISSUE"] = "tissue";
  CommodityEnum["BOATS"] = "boats";
  CommodityEnum["GLASS_BOTTLES"] = "glassBottles";
  CommodityEnum["PLASTIC_BOTTLES"] = "plasticBottles";
  CommodityEnum["BUILDING_MATERIALS"] = "buildingMaterials";
  CommodityEnum["BULLION"] = "bullion";
  CommodityEnum["BUTTER"] = "butter";
  CommodityEnum["CANDY"] = "candy";
  CommodityEnum["CANNED_GOODS"] = "cannedGoods";
  CommodityEnum["CARPETS"] = "carpets";
  CommodityEnum["CASKETS"] = "caskets";
  CommodityEnum["TAPES"] = "tapes";
  CommodityEnum["CEMENT"] = "cement";
  CommodityEnum["CHEESE"] = "cheese";
  CommodityEnum["CHEMICALS"] = "chemicals";
  CommodityEnum["GLASSWARE"] = "glassware";
  CommodityEnum["TOBACCO_PRODUCTS"] = "tobaccoProducts";
  CommodityEnum["ATHLETIC_CLOTHING"] = "athleticClothing";
  CommodityEnum["BLUE_JEANS"] = "blueJeans";
  CommodityEnum["FURS"] = "furs";
  CommodityEnum["DESIGNER_CLOTHING"] = "designerClothing";
  CommodityEnum["TEE_SHIRTS"] = "teeShirts";
  CommodityEnum["OTHER_CLOTHING"] = "otherClothing";
  CommodityEnum["COAL"] = "coal";
  CommodityEnum["EQUIPMENT"] = "equipment";
  CommodityEnum["OVERSIZED_EQUIPMENT"] = "oversizedEquipment";
  CommodityEnum["OVER500MILE_FREIGHT"] = "over500MileFreight";
  CommodityEnum["UPTO500MILE_FREIGHT"] = "upto500MileFreight";
  CommodityEnum["COPPER"] = "copper";
  CommodityEnum["COSMETICS"] = "cosmetics";
  CommodityEnum["COTTON"] = "cotton";
  CommodityEnum["DEPT_STORES_WALMART"] = "deptStoresWalmart";
  CommodityEnum["MACYS"] = "macys";
  CommodityEnum["EGGS"] = "eggs";
  CommodityEnum["ELECTRICAL_SUPPLIES"] = "electricalSupplies";
  CommodityEnum["ELECTRONIC_EQUIP"] = "electronicEquip";
  CommodityEnum["FARM_MACHINERY"] = "farmMachinery";
  CommodityEnum["OVERSIZED_FARM_MACHINERY"] = "oversizedFarmMachinery";
  CommodityEnum["FEED"] = "feed";
  CommodityEnum["FERTILIZER"] = "fertilizer";
  CommodityEnum["BULK_FERTILIZER"] = "bulkFertilizer";
  CommodityEnum["CABLE"] = "cable";
  CommodityEnum["FINE_ARTS"] = "fineArts";
  CommodityEnum["FIRE_ARMS"] = "fireArms";
  CommodityEnum["FLOUR"] = "flour";
  CommodityEnum["FLOWERS"] = "flowers";
  CommodityEnum["FROZEN_FOOD"] = "frozenFood";
  CommodityEnum["FURNITURE"] = "furniture";
  CommodityEnum["GENERAL_FREIGHT"] = "generalFreight";
  CommodityEnum["GOLF_CARTS"] = "golfCarts";
  CommodityEnum["GLASS"] = "glass";
  CommodityEnum["GRAIN"] = "grain";
  CommodityEnum["ROCK"] = "rock";
  CommodityEnum["GROCERIES"] = "groceries";
  CommodityEnum["HARDWARE"] = "hardware";
  CommodityEnum["HAY"] = "hay";
  CommodityEnum["HOUSE_GOODS"] = "houseGoods";
  CommodityEnum["ICE_CREAM"] = "iceCream";
  CommodityEnum["IRON"] = "iron";
  CommodityEnum["JEWELERY"] = "jewelery";
  CommodityEnum["JUICE"] = "juice";
  CommodityEnum["LIVESTOCK_OVER300MILES"] = "livestockOver300Miles";
  CommodityEnum["LIVESTOCK_UPTO300MILES"] = "livestockUpto300Miles";
  CommodityEnum["LOGS"] = "logs";
  CommodityEnum["LUMBER"] = "lumber";
  CommodityEnum["HEAVY_MACHINERY"] = "heavyMachinery";
  CommodityEnum["LIGHT_MACHINERY"] = "lightMachinery";
  CommodityEnum["LIGHT_MACHINERY_FLAT_BED"] = "lightMachineryFlatBed";
  CommodityEnum["IMAGING_UNITS"] = "imagingUnits";
  CommodityEnum["BOXED_MEAT"] = "boxedMeat";
  CommodityEnum["MEAT_SWINGING"] = "meatSwinging";
  CommodityEnum["MEDICAL_EQUIPMENT"] = "medicalEquipment";
  CommodityEnum["EXPENSIVE_MEDICAL_EQUIPMENT"] = "expensiveMedicalEquipment";
  CommodityEnum["COLLECTIBLES"] = "collectibles";
  CommodityEnum["FINISHED_METAL"] = "finishedMetal";
  CommodityEnum["NON_FERROUS_METAL"] = "nonFerrousMetal";
  CommodityEnum["MILK"] = "milk";
  CommodityEnum["MOBILE_HOMES"] = "mobileHomes";
  CommodityEnum["MONEY"] = "money";
  CommodityEnum["MOTORCYCLES"] = "motorcycles";
  CommodityEnum["MULCH"] = "mulch";
  CommodityEnum["MUSICAL_INSTRUMENTS"] = "musicalInstruments";
  CommodityEnum["OFFICE_EQUIPMENT"] = "officeEquipment";
  CommodityEnum["ORE"] = "ore";
  CommodityEnum["ORIENTAL_RUGS"] = "orientalRugs";
  CommodityEnum["OVERWEIGHT_ITEMS"] = "overweightItems";
  CommodityEnum["PALLETS"] = "pallets";
  CommodityEnum["PAPER_PRODUCTS"] = "paperProducts";
  CommodityEnum["PERFUME"] = "perfume";
  CommodityEnum["PETROLEUM_PRODUCTS"] = "petroleumProducts";
  CommodityEnum["PHARMACEUTICALS_OTC"] = "pharmaceuticalsOTC";
  CommodityEnum["PHARMACEUTICALS_PRESCRIPTION"] = "pharmaceuticalsPrescription";
  CommodityEnum["VIDEO_EQUIP"] = "videoEquip";
  CommodityEnum["PIANOS"] = "pianos";
  CommodityEnum["PINE_NEEDLES"] = "pineNeedles";
  CommodityEnum["PLANTS_NOT_TEMP_CONTROLLED"] = "plantsNotTempControlled";
  CommodityEnum["PLANTS_TEMP_CONTROLLED"] = "plantsTempControlled";
  CommodityEnum["PLASTICS_PRODUCTS"] = "plasticsProducts";
  CommodityEnum["PLUMBING_SUPPLIES"] = "plumbingSupplies";
  CommodityEnum["POULTRY"] = "poultry";
  CommodityEnum["PRECIOUS_METALS"] = "preciousMetals";
  CommodityEnum["PRODUCE"] = "produce";
  CommodityEnum["RAIL_ROAD"] = "railRoad";
  CommodityEnum["RECREATIONAL_VEHICLES"] = "recreationalVehicles";
  CommodityEnum["PETROL_PRODS"] = "petrolProds";
  CommodityEnum["RIGGING"] = "rigging";
  CommodityEnum["RUBBER_PRODUCTS"] = "rubberProducts";
  CommodityEnum["SALT_BULK"] = "saltBulk";
  CommodityEnum["SAND"] = "sand";
  CommodityEnum["SEAFOOD_FRESH"] = "seafoodFresh";
  CommodityEnum["SEAFOOD_FROZEN"] = "seafoodFrozen";
  CommodityEnum["SECURITIES"] = "securities";
  CommodityEnum["SHOES"] = "shoes";
  CommodityEnum["REGULAR_SHOES"] = "regularShoes";
  CommodityEnum["SOLAR_PANELS"] = "solarPanels";
  CommodityEnum["SPAS_PERSONAL"] = "spasPersonal";
  CommodityEnum["SPAS_COMMERCIAL"] = "spasCommercial";
  CommodityEnum["SPORTING_GOODS"] = "sportingGoods";
  CommodityEnum["STATIONARY"] = "stationary";
  CommodityEnum["RAW_STEEL"] = "rawSteel";
  CommodityEnum["STONE_PRODUCTS"] = "stoneProducts";
  CommodityEnum["SWIMMING_POOLS"] = "swimmingPools";
  CommodityEnum["TAR"] = "tar";
  CommodityEnum["TEXTILES"] = "textiles";
  CommodityEnum["TIRES"] = "tires";
  CommodityEnum["RAW_TOBACCO"] = "rawTobacco";
  CommodityEnum["TOOLS"] = "tools";
  CommodityEnum["TOP_SOIL"] = "topSoil";
  CommodityEnum["TOYS_CRAFTS"] = "toysCrafts";
  CommodityEnum["TRANSFORMERS"] = "transformers";
  CommodityEnum["GARBAGE"] = "garbage";
  CommodityEnum["TURBINES"] = "turbines";
  CommodityEnum["WIRING"] = "wiring";
  CommodityEnum["WOOD_PRODUCTS"] = "woodProducts";
  CommodityEnum["OTHER_COMMODITY"] = "otherCommodity";
})(CommodityEnum || (CommodityEnum = {}));